import { render, staticRenderFns } from "./ClassOverviewCard.vue?vue&type=template&id=6ea0bdc6&scoped=true"
import script from "./ClassOverviewCard.vue?vue&type=script&lang=js"
export * from "./ClassOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./ClassOverviewCard.vue?vue&type=style&index=0&id=6ea0bdc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea0bdc6",
  null
  
)

export default component.exports